import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=541f6120&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=541f6120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f6120",
  null
  
)

component.options.__file = "www/vues/login/ForgotPassword.vue"
export default component.exports